import { Suspense, lazy } from "react";
import { Routes, Route, Navigate, useRoutes } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import HomePage from "./components/home/HomePage";

// Lazy load service pages with reduced chunk size
const BusinessIncorporationPage = lazy(
  () => import("./components/services/BusinessIncorporationPage"),
);
const BankingPage = lazy(() => import("./components/services/BankingPage"));
const TaxPage = lazy(() => import("./components/services/TaxPage"));
const GoldenVisaPage = lazy(
  () => import("./components/services/GoldenVisaPage"),
);
const VisaPage = lazy(() => import("./components/services/VisaPage"));
const AccountingPage = lazy(
  () => import("./components/services/AccountingPage"),
);
const ITServicesPage = lazy(
  () => import("./components/services/ITServicesPage"),
);

// New service pages
import BusinessSetupPage from "./components/services/BusinessSetupPage";
const AccountingAndTaxesPage = lazy(
  () => import("./components/services/AccountingAndTaxesPage"),
);
const ProAndVisaPage = lazy(() => import("./components/services/pro-and-visa"));

// Import FAQPage component
import FAQPage from "./components/layout/FAQPage";

function App() {
  // Import tempo routes if in tempo environment
  // Using a more memory-efficient approach
  if (import.meta.env.VITE_TEMPO === "true") {
    try {
      // Dynamic import with no variable assignment to reduce memory pressure
      import("tempo-routes").catch((error) => {
        console.warn("Tempo routes not available", error);
      });
    } catch (error) {
      console.warn("Tempo routes not available", error);
    }
  }

  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="inline-block animate-spin h-8 w-8 border-4 border-blue-600 border-t-transparent rounded-full mb-4"></div>
            <p>Loading...</p>
          </div>
        </div>
      }
    >
      {/* Tempo routes are handled by the plugin */}
      {import.meta.env.VITE_TEMPO === "true" && useRoutes([])}

      {/* Tempo routes are handled by the plugin */}
      {import.meta.env.VITE_TEMPO === "true" && useRoutes([])}

      <Routes>
        <Route path="/" element={<HomePage />} />

        {/* Service Routes */}
        <Route
          path="/services/incorporation"
          element={<BusinessIncorporationPage />}
        />
        <Route path="/services/banking" element={<BankingPage />} />
        <Route path="/services/tax" element={<TaxPage />} />
        <Route path="/services/golden-visa" element={<GoldenVisaPage />} />
        <Route path="/services/visa" element={<VisaPage />} />
        <Route path="/services/accounting" element={<AccountingPage />} />
        <Route path="/services/it" element={<ITServicesPage />} />

        {/* New service routes */}
        <Route
          path="/services/business-setup"
          element={<BusinessSetupPage />}
        />
        <Route
          path="/services/accounting-and-taxes"
          element={<AccountingAndTaxesPage />}
        />
        <Route path="/services/pro-and-visa" element={<ProAndVisaPage />} />

        {/* FAQ Page */}
        <Route path="/faqs" element={<FAQPage />} />

        {/* Add this before the catchall route for tempo */}
        {import.meta.env.VITE_TEMPO === "true" && <Route path="/tempobook/*" />}

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Analytics />
    </Suspense>
  );
}

export default App;
